import { checkClaimsWeb } from '@eventr/common'
import { createContext, useContext } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { getNotParsedUrlParam } from '../utils'
import { bs, useBoundStore } from './bound.store'
interface IRouteGuardContext {
    isAllowed: (guardCallbacks: CallbackTypes[]) => boolean
}

const RouteGuardContext = createContext<IRouteGuardContext>({
    isAllowed: () => true,
})

export type CallbackTypes =
    | 'alreadySignedIn'
    | 'allowedInviteUsers'
    | 'checkAdmin'
    | 'allowedEdit'
    | 'allowedCreateNewItin'

export const RouteGuardProvider = (props: { children: React.ReactNode }) => {
    const { orgConfig, profile, IDtoken } = useBoundStore(
        useShallow((s) => {
            return {
                orgConfig: s.orgConfig,
                profile: s.profile,
                IDtoken: s.IDtoken,
            }
        })
    )

    const callbackFunctions: { [key in CallbackTypes]: () => boolean } = {
        alreadySignedIn: () => {
            const urlEmail = getNotParsedUrlParam('email')
            const parsedEmail = decodeURIComponent(urlEmail)

            if (!urlEmail) {
                if (IDtoken) return false
            }
            if (
                urlEmail &&
                profile?.email?.toLowerCase() === parsedEmail.toLowerCase()
            )
                return false
            return true
        },
        allowedInviteUsers: () => {
            return (
                !orgConfig.userInviteDisabled &&
                checkAllowEdit() &&
                checkClaimsWeb([`/`], ['createUser']) &&
                bs().selectedItinID !== -1
            )
        },
        allowedEdit: () => {
            return checkAllowEdit()
        },
        checkAdmin: () => {
            return checkAdmin()
        },
        allowedCreateNewItin: () => {
            return checkAllowedCreateNewItin()
        },
    }

    const isAllowed = (guardCallbacks: CallbackTypes[]) => {
        if (guardCallbacks.length === 0) return true
        for (const callback of guardCallbacks) {
            if (!callbackFunctions[callback]()) return false
        }
        return true
    }

    const checkAllowEdit = () => {
        if (orgConfig?.editInAppDisabled === undefined) return false
        if (orgConfig?.editInAppDisabled) return false
        if (orgConfig?.adminEditOnly) {
            if (checkAdmin()) {
                return true
            }
            return false
        }

        return checkClaimsWeb([`/`], ['editItinerary'])
    }

    const checkAllowedCreateNewItin = () => {
        if (orgConfig?.editInAppDisabled === undefined) return false
        if (orgConfig?.editInAppDisabled) return false
        if (orgConfig?.adminEditOnly) {
            if (checkAdmin()) {
                return true
            }
            return false
        }
        return checkClaimsWeb(['/'], ['createItinerary'])
    }
    const checkAdmin = () => {
        return checkClaimsWeb(['/'], ['full'])
    }

    return (
        <RouteGuardContext.Provider
            value={{
                isAllowed,
            }}
        >
            {props.children}
        </RouteGuardContext.Provider>
    )
}

export const useRouteGuardContext = () => {
    return useContext(RouteGuardContext)
}
